import styled from "@emotion/styled";

import { BaseLink } from "~/components/common/base-link";

import IconClose from "./icon-close.svg";

export const CloseButton = styled(BaseLink)`
  position: absolute;
  inset-block-start: 24px;
  inset-inline-end: 15px;
  z-index: 3;

  ${props => props.theme.breakpoints.up("tablet")} {
    inset-block-start: 33px;
  }
`;

export const CloseLogo = styled(IconClose)`
  inline-size: 18px;
  block-size: 18px;
`;
